import { Flex } from "@chakra-ui/react";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { InfoAlert } from "src/components/Feedback/InfoAlert";
import {
  FormContext,
  FormTemplateContext,
} from "src/components/Providers/FormProvider";
import { useOrganizationPath } from "src/hooks/useOrganizationPath";
import { isInProgressAndCanEditCheck } from "src/scenes/parent/forms/formEditability";
import * as Url from "src/services/url";
import * as GQL from "src/types/graphql";

type Props = {
  children: (editMode: "InProgress" | "BackInProgress") => React.ReactNode;
  formId: string;
  formContext: FormContext;
  formTemplateContext: FormTemplateContext;
  loading: React.ReactNode;
};

export type EditMode = "Loading" | "InProgress" | "BackInProgress" | "Locked";
export const EnforceFormEditability: React.FC<Props> = ({
  children,
  formId,
  formContext,
  formTemplateContext,
  loading,
}) => {
  const isInProgressAndCanEdit = isInProgressAndCanEditCheck(
    formTemplateContext.gql.sections,
    formTemplateContext.gql.enrollment_period,
    formContext.status
  );
  const [editMode, setEditMode] = React.useState<EditMode>("Loading");
  const orgPath = useOrganizationPath();
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(
    () => {
      (async () => {
        if (
          formContext.status === GQL.form_status_enum.Verified ||
          formContext.status === GQL.form_status_enum.LotteryReady
        ) {
          setEditMode("Locked");
          setTimeout(() => {
            navigate(`/${orgPath}`);
          }, 2000);
        } else if (!isInProgressAndCanEdit) {
          setEditMode("Locked");
          setTimeout(() => {
            navigate(Url.Parent.Form.view({ path: orgPath ?? "" }, formId));
          }, 2000);
        } else if (location.state === ("BackInProgress" satisfies EditMode)) {
          setEditMode("BackInProgress");
        } else {
          setEditMode("InProgress");
        }
      })();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  if (editMode === "Loading") {
    return loading;
  }

  if (editMode === "Locked") {
    return (
      <Flex direction="column">
        <InfoAlert>Redirecting...</InfoAlert>
      </Flex>
    );
  }

  return children(editMode);
};
